

    function close(){
        $('.search-filter > li > select').blur();
    }
$(document).ready(function() {
    //if there is no old modules on the page, remove the wrapper div
    if(document.querySelector('.main-content')){
        if( document.querySelector('.main-content').innerHTML.trim() == '')
        {document.querySelector('.main-content').style.display = "none"}
    }
    //if there is no content in the sidebar, then remove it
    if(document.querySelector('.sidebar__content')){
        if( document.querySelector('.sidebar__content').innerHTML.trim() == '')
        {document.querySelector('.sidebar__content').style.display = "none"}
    }
    //if window is resized, close select dropdown  
    $(window).resize(close);
    $(window).on('orientationchange',close)
});

define("newModules", function(){});

